module.exports = __webpack_public_path__ + "static/media/clean2.96802237.png";